const swConfig = {
  onUpdate: (registration) => {
    registration.unregister().then(() => {
      window.location.reload()
      console.info('service worker on update state')
    })
  },
  onSuccess: (registration) => {
    console.info('service worker on success state')
  },
}

export default swConfig
